import { Button, Dialog } from '@/components/UI'
import { IconAlertCircleFilled } from '@tabler/icons-react'

type Props = {
  opened: boolean
  onClose: () => void
  /** エラーメッセージ（未指定の場合はデフォルトメッセージを表示） */
  message?: string
  onRetry: () => void
}

/**
 * 応募失敗ダイアログ。
 * 応募処理が失敗したことを通知し、リトライを促す。
 * 完了ダイアログと同形のレイアウト。
 */
export function DialogV2ApplyFailed({ opened, onClose, message, onRetry }: Props) {
  return (
    <Dialog selectorState={opened} closeFunc={onClose} title="エラー" compact>
      <div className="flex flex-col items-center gap-4 px-4 py-6">
        <IconAlertCircleFilled size={56} className="text-red-400" aria-hidden="true" />
        <p className="text-center text-[15px] font-bold leading-[24px] text-black">処理に失敗しました</p>
        <p className="text-center text-[13px] leading-[20px] text-gray-600">
          {message ?? 'しばらく時間をおいてから再度お試しください。'}
        </p>
        <Button label="再試行する" variant="primary" size="md" fullWidth onClick={onRetry} />
        <button
          type="button"
          className="flex h-[48px] w-full items-center justify-center rounded-[8px] border border-gray-300 text-[15px] font-bold text-gray-600"
          onClick={onClose}
        >
          閉じる
        </button>
      </div>
    </Dialog>
  )
}
